<template>
    <div style="display: flex; flex-wrap: wrap;">
        <v-row class="row">
            <v-col cols="4">
                <div class="champs">
                    <div class="ligne">
                        <div class="nom">{{ $t('_societe_') }} (*)</div>
                        <div class="complement"> - {{ $t('_nom_de_la_societe_cliente_') }}</div>
                    </div>
                    <v-text-field label="" outlined class="inputField" v-model="reponse.societe.value"></v-text-field>
                </div>

                <div class="champs">
                    <div class="nom">{{ $t('_reference_interne_') }}</div>
                    <v-text-field label="" outlined class="inputField" v-model="reponse.reference.value"></v-text-field>
                </div>
                <div class="champs">
                    <div class="ligne">
                        <div class="nom">{{ $t('_nom_du_projet_') }} (*)</div>
                        <div class="complement"> - {{ $t('_nom_du_site_') }}</div>
                    </div>
                    <v-text-field label="" outlined class="inputField" v-model="reponse.nom.value"></v-text-field>
                </div>

                <div class="champs">
                    <div class="nom">{{ $t('_adresse_') }}</div>
                    <v-text-field label="" outlined class="inputField" v-model="reponse.adresse.value"
                        @input="geocodeAddress"></v-text-field>
                </div>
            </v-col>
            <v-col cols="8">
                <l-map ref="refMap" class="small-map" :zoom="zoom" :center="centre" @update:zoom="zoomUpdated"
                    @update:center="centerUpdated" @update:contours="boundsUpdated">
                    <l-tile-layer v-for="tileProvider in tileProviders" :key="tileProvider.name"
                        :name="tileProvider.name" :visible="tileProvider.visible"
                        :url="tileProvider.url"></l-tile-layer>
                    <l-marker ref="mapRef" @ready="map_ready" :draggable=true
                        :lat-lng="[reponse.markerLatLng0.value, reponse.markerLatLng1.value]">
                    </l-marker>

                </l-map>
            </v-col>
        </v-row>
        <v-row class="row">
            <v-col cols="4">
                <div class="input mb-2">
                    <div style="width: 100%;">
                        <div class="nom"> {{ $t('_code_postal_') }}</div>
                        <v-text-field label="" outlined class="inputField" v-model="reponse.codePostal.value"
                            @input="geocodeAddress"></v-text-field>
                    </div>
                    <div style="width: 100%;">
                        <div class="nom">{{ $t('_ville_') }}</div>
                        <v-text-field label="" outlined class="inputField" v-model="reponse.ville.value"
                            @input="geocodeAddress"></v-text-field>
                    </div>
                </div>
                <!-- <div v-if="this.reponse.codePostal.value.length !== 5 && this.reponse.codePostal.value.length !== 0"
                    class="warn">{{ $t('_attention_code_postal_') }}</div> -->

            </v-col>
            <v-col cols="4">
                <div class="ligne">
                    <div class="nom">{{ $t('_latitude_') }} (*)</div>
                    <div class="complement"> - {{ $t('_valeur_decimale_') }}</div>
                </div>
                <v-text-field label="" outlined class="inputField" v-model="reponse.markerLatLng0.value"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
            </v-col>
            <v-col cols="4">
                <div class="ligne">
                    <div class="nom"> {{ $t('_longitude_') }} (*)</div>
                    <div class="complement"> - {{ $t('_valeur_decimale_') }}</div>
                </div>
                <v-text-field label="" outlined class="inputField" v-model="reponse.markerLatLng1.value"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
            </v-col>
        </v-row>
        <v-row class="row">
            <v-col cols="4">
                <div style="display: flex; flex-wrap: nowrap; gap: 2%">
                    <div style="width: 48%;">
                        <div class="nom">{{ $t('_puissance_installee_') }}</div>
                        <div class="input">
                            <v-text-field label="" outlined class="inputField" v-model="reponse.pInstallee.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                            <div class="unit"> Wc</div>
                        </div>

                    </div>
                    <div style="width: 48%;">
                        <div class="nom">{{ $t('_puissance_souscrite_') }}</div>
                        <div class="input">
                            <v-text-field label="" outlined class="inputField" v-model="reponse.pSouscite.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                            <div class="unit"> VA</div>
                        </div>

                    </div>
                </div>


                <div class="nom">{{ $t('_date_de_mise_en_service_elec_') }} (*)</div>
                <input class="date" type="date" v-model="reponse.elecDate.value" />
                <div class="nom">{{ $t('_date_de_mise_en_service_elec_') }}</div>
                <input class="date" type="date" v-model="reponse.monoDate.value" />
                <div class="ligne">
                    <div class="nom">{{ $t('_prm_') }}</div>
                    <div class="complement"> - {{ $t('_si_applicable_') }}</div>
                </div>
                <v-text-field label="" outlined class="inputField" v-model="reponse.prm.value"></v-text-field>

                <div class="nom"> {{ $t('_tarif_de_rachat_') }}</div>
                <div class="input">
                    <v-text-field label="" outlined class="inputField" v-model="reponse.tarif.value"
                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                    <div class="unit"> €/kWh</div>
                </div>
            </v-col>
            <v-col cols="4">
                <div class="nom"> {{ $t('_timezone_donnees_prod_') }} (*)</div>
                <select class="createSelect" v-model="reponse.utcProd.value">
                    <option v-for="(utc, index) in this.UTCs" :key=index> {{ utc }} </option>
                </select>
                <div class="nom"> {{ $t('_timezone_meteo_') }} (*)</div>
                <select class="createSelect" v-model="reponse.utcMeteo.value">
                    <option v-for="(utc, index) in this.UTCs" :key=index> {{ utc }} </option>
                </select>
                <div class="nom">{{ $t('_timezone_meteo_') }} {{ $t('_in_situ_') }}u (*)</div>
                <select class="createSelect" v-model="reponse.utcMeteoInSitu.value">
                    <option v-for="(utc, index) in this.UTCs" :key=index> {{ utc }} </option>
                </select>
                <div class="nom"> {{ $t('_timezone_donnees_compteur_') }} (*)</div>
                <select class="createSelect" v-model="reponse.utcData.value">
                    <option v-for="(utc, index) in this.UTCs" :key=index> {{ utc }} </option>
                </select>
            </v-col>
            <v-col cols="4">
                <div class="nom">{{ $t('_date_de_debut_d_analyse_') }} (*)</div>
                <input class="date" type="date" v-model="reponse.dateDebut.value" />
                <div class="nom">{{ $t('_date_de_fin_d_analyse_') }} (*)</div>
                <input class="date" type="date" v-model="reponse.dateFin.value" />

                <div v-if="this.reponse.dateFin.value !== '' && this.reponse.dateDebut.value !== '' && this.reponse.dateFin.value < this.reponse.dateDebut.value"
                    class="warn">{{ $t('_attention_la_date_de_fin_d\'audit_') }}</div>

                <div class="nom"> {{ $t('_type_de_calepinage_') }} (*)</div>
                <select class="createSelect" v-model="reponse.typeCalepinage.value">
                    <option> {{ $t('_global_') }}</option>
                    <option> {{ $t('_detaille_') }}</option>
                </select>
            </v-col>
        </v-row>
    </div>

</template>

<script>
import { LMap, LTileLayer } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { debounce } from 'lodash';
import moment from 'moment-timezone';
// import {  EsriProvider } from 'leaflet-geosearch';
// import 'node_modules/leaflet-geosearch/dist/geosearch.css';
// import L from 'leaflet';

export default {
    components: { LMap, LTileLayer },

    props: {
        initDescr: {
            required: false,
        }
    },

    data() {
        return {
            UTCs: moment.tz.names(),
            reponse: {
                societe: {
                    value: "",
                    required: true,
                },
                reference: {
                    value: "",
                    required: false,
                },
                nom: {
                    value: "",
                    required: true,
                },
                adresse: {
                    value: "",
                    required: false,
                },
                codePostal: {
                    value: "",
                    required: false,
                },
                ville: {
                    value: "",
                    required: false,
                },
                markerLatLng0: {
                    value: 0,
                    required: true,
                },
                markerLatLng1: {
                    value: 0,
                    required: false,
                },
                pInstallee: {
                    value: null,
                    required: false,
                },
                pSouscite: {
                    value: null,
                    required: false,
                },
                elecDate: {
                    value: "",
                    required: true,
                },
                monoDate: {
                    value: null,
                    required: false,
                },
                prm: {
                    value: null,
                    required: false,
                },
                tarif: {
                    value: null,
                    required: false,
                },
                utcProd: {
                    value: "Europe/Paris",
                    required: true,
                },
                utcMeteo: {
                    value: "Europe/Paris",
                    required: true,
                },
                utcMeteoInSitu: {
                    value: "Europe/Paris",
                    required: true,
                },
                utcData: {
                    value: "Europe/Paris",
                    required: true,
                },
                dateDebut: {
                    value: "",
                    required: true,
                },
                dateFin: {
                    value: "",
                    required: true,
                },
                typeCalepinage: {
                    value: "",
                    required: true,
                },


            },

            mapRef: null,
            marker: null,
            contours: null,
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            zoom: 17,
            centre: [48.866667, 2.333333],
            tileProviders: [
                {
                    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
                    visible: true,
                    name: "satelliteESRI",
                    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
                },
            ],
        }
    },

    watch: {
        reponse: {
            //a chaque modification de la reponse on regarde si elle est complete et on envoie les reponse a PopupCreation.vue  
            handler() {
                this.$refs.refMap.mapObject.setView([this.reponse.markerLatLng0.value, this.reponse.markerLatLng1.value], 17)
                this.$forceUpdate()
                this.iscomplete();
                var onlyValues = {}
                for (var champ in this.reponse) {
                    onlyValues[champ] = this.reponse[champ].value
                }
                this.$emit("answer", onlyValues)
            }, deep: true
        },

        initDescr: {
            handler() {
                this.getInitValues()
            },
            deep: true,
        }

    },

    mounted() {
        this.getInitValues()
    },

    methods: {
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        centerUpdated(centre) {
            this.centre = centre;
        },
        boundsUpdated(contours) {
            this.contours = contours;
        },

        //une seconde apres que l'utilisateur ait arreté d'ecrire dans adresse, chercher les coordonnées de l'adresse puis y met le marker
        geocodeAddress: debounce(function () {
            this.adresseToCoordonnees()
                .then(coordonnees => {
                    if (coordonnees) {
                        this.reponse.markerLatLng0.value = coordonnees.latitude
                        this.reponse.markerLatLng1.value = coordonnees.longitude
                        this.centre = [this.reponse.markerLatLng0.value, this.reponse.markerLatLng1.value]
                        this.$forceUpdate
                    }
                });
        }, 1000),

        //cherche les coordonnées de l'adresse
        async adresseToCoordonnees() {
            const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.reponse.adresse.value + " " + this.reponse.codePostal.value + " " + this.reponse.ville.value)}`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (data && data.length > 0) {
                    // Récupérer la première correspondance
                    const latitude = data[0].lat;
                    const longitude = data[0].lon;
                    return { latitude, longitude };
                } else {
                    console.log("Aucune correspondance trouvée");
                    return null;
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des données :", error);
                return null;
            }

        },
        map_ready() {
            this.$refs.mapRef.mapObject.on('dragend', () => {
                this.reponse.markerLatLng0.value = this.$refs.mapRef.mapObject._latlng.lat
                this.reponse.markerLatLng1.value = this.$refs.mapRef.mapObject._latlng.lng
            });
        },
        //si tout les champs obligatoirs sont rempli, le bouton suivant est activé
        iscomplete() {
            let complete = true
            for (var champs in this.reponse) {
                if (this.reponse[champs].required === true)
                    if (this.reponse[champs].value === "" || this.reponse[champs].value === null) {
                        complete = false
                    }
            }
            if (this.reponse.dateFin.value !== '' && this.reponse.dateDebut.value !== '' && this.reponse.dateFin.value < this.reponse.dateDebut.value)
                complete = false
            if (complete === true)
                this.$emit("enable")
            else
                this.$emit("disable")

        },
        //initialise la date d'instalation à la date du jour, pre rempli le formulaire avec les données deja enregistées et centre la carte sur le marker
        getInitValues() {
            const today = new Date();

            const day = String(today.getDate()).padStart(2, '0');     // Jour (2 chiffres)
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (2 chiffres, attention +1)
            const year = today.getFullYear();

            this.reponse.elecDate.value = `${year}-${month}-${day}`
            this.reponse.dateDebut.value = `${year}-${month}-${day}`
            if (this.initDescr !== undefined && this.initDescr !== null) {
                for (var champ in this.initDescr) {
                    this.reponse[champ].value = this.initDescr[champ]
                }
                this.centre = [this.reponse.markerLatLng0.value, this.reponse.markerLatLng1.value]
                this.centerUpdated(this.centre)
            }
        }
    }
}
</script>

<style scoped>

.ligne {
    display: flex;
    flex-wrap: wrap;
    gap: 10px
}

.unit {
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}

.row {
    width: 100%;
}
</style>